import { createAction } from 'redux-actions';

export const FNB_GET_OUTLETS = 'FNB_GET_OUTLETS';
export const FNB_GET_OUTLETS_SUCCESS = 'FNB_GET_OUTLETS_SUCCESS';
export const FNB_GET_OUTLETS_FAIL = 'FNB_GET_OUTLETS_FAIL';

export const FNB_GET_PROPERTIES = 'FNB_GET_PROPERTIES';
export const FNB_GET_PROPERTIES_SUCCESS = 'FNB_GET_PROPERTIES_SUCCESS';
export const FNB_GET_PROPERTIES_FAIL = 'FNB_GET_PROPERTIES_FAIL';

export const FNB_SYNC_OUTLETS = 'FNB_SYNC_OUTLETS';
export const FNB_SYNC_OUTLETS_SUCCESS = 'FNB_SYNC_OUTLETS_SUCCESS';
export const FNB_SYNC_OUTLETS_FAIL = 'FNB_SYNC_OUTLETS_FAIL';
export const FNB_UPDATE_OUTLET = 'FNB_UPDATE_OUTLET';
export const FNB_UPDATE_OUTLET_SUCCESS = 'FNB_UPDATE_OUTLET_SUCCESS';
export const FNB_UPDATE_OUTLET_FAIL = 'FNB_UPDATE_OUTLET_FAIL';

export const FNB_GET_MENUS = 'FNB_GET_MENUS';
export const FNB_GET_MENUS_SUCCESS = 'FNB_GET_MENUS_SUCCESS';
export const FNB_GET_MENUS_FAIL = 'FNB_GET_MENUS_FAIL';

export const FNB_SYNC_MENUS = 'FNB_SYNC_MENUS';
export const FNB_SYNC_MENUS_SUCCESS = 'FNB_SYNC_MENUS_SUCCESS';
export const FNB_SYNC_MENUS_FAIL = 'FNB_SYNC_MENUS_FAIL';

export const FNB_SYNC_MENU_ITEMS = 'FNB_SYNC_MENU_ITEMS';
export const FNB_SYNC_MENU_ITEMS_SUCCESS = 'FNB_SYNC_MENU_ITEMS_SUCCESS';
export const FNB_SYNC_MENU_ITEMS_FAIL = 'FNB_SYNC_MENU_ITEMS_FAIL';

export const FNB_GET_MENU_ITEMS = 'FNB_GET_MENU_ITEMS';
export const FNB_GET_MENU_ITEMS_SUCCESS = 'FNB_GET_MENU_ITEMS_SUCCESS';
export const FNB_GET_MENU_ITEMS_FAIL = 'FNB_GET_MENU_ITEMS_FAIL';

export const FNB_UPDATE_MENU_ITEM = 'FNB_UPDATE_MENU_ITEM';
export const FNB_UPDATE_MENU_ITEM_SUCCESS = 'FNB_UPDATE_MENU_ITEM_SUCCESS';
export const FNB_UPDATE_MENU_ITEM_FAIL = 'FNB_UPDATE_MENU_ITEM_FAIL';

export const FNB_GET_MENU_DETAIL = 'FNB_GET_MENU_DETAIL';
export const FNB_GET_MENU_DETAIL_SUCCESS = 'FNB_GET_MENU_DETAIL_SUCCESS';
export const FNB_GET_MENU_DETAIL_FAIL = 'FNB_GET_MENU_DETAIL_FAIL';

export const FNB_UPDATE_MENU = 'FNB_UPDATE_MENU';
export const FNB_UPDATE_MENU_SUCCESS = 'FNB_UPDATE_MENU_SUCCESS';
export const FNB_UPDATE_MENU_FAIL = 'FNB_UPDATE_MENU_FAIL';

export const FNB_MENU_TRANSLATE = 'FNB_MENU_TRANSLATE';
export const FNB_MENU_TRANSLATE_SUCCESS = 'FNB_MENU_TRANSLATE_SUCCESS';
export const FNB_MENU_TRANSLATE_FAIL = 'FNB_MENU_TRANSLATE_FAIL';
export const FNB_MENU_TRANSLATE_DELETE = 'FNB_MENU_TRANSLATE_DELETE';
export const FNB_MENU_TRANSLATE_DELETE_SUCCESS = 'FNB_MENU_TRANSLATE_DELETE_SUCCESS';
export const FNB_MENU_TRANSLATE_DELETE_FAIL = 'FNB_MENU_TRANSLATE_DELETE_FAIL';

export const FNB_GET_ITEM_DETAIL = 'FNB_GET_ITEM_DETAIL';
export const FNB_GET_ITEM_DETAIL_SUCCESS = 'FNB_GET_ITEM_DETAIL_SUCCESS';
export const FNB_GET_ITEM_DETAIL_FAIL = 'FNB_GET_ITEM_DETAIL_FAIL';

export const FNB_GET_CONDIMENTS = 'FNB_GET_CONDIMENTS';
export const FNB_GET_CONDIMENTS_SUCCESS = 'FNB_GET_CONDIMENTS_SUCCESS';
export const FNB_GET_CONDIMENTS_FAIL = 'FNB_GET_CONDIMENTS_FAIL';

export const FNB_SYNC_CONDIMENTS = 'FNB_SYNC_CONDIMENTS';
export const FNB_SYNC_CONDIMENTS_SUCCESS = 'FNB_SYNC_CONDIMENTS_SUCCESS';
export const FNB_SYNC_CONDIMENTS_FAIL = 'FNB_SYNC_CONDIMENTS_FAIL';

export const FNB_GET_CONDIMENT_DETAIL = 'FNB_GET_CONDIMENT_DETAIL';
export const FNB_GET_CONDIMENT_DETAIL_SUCCESS = 'FNB_GET_CONDIMENT_DETAIL_SUCCESS';
export const FNB_GET_CONDIMENT_DETAIL_FAIL = 'FNB_GET_CONDIMENT_DETAIL_FAIL';

export const FNB_UPDATE_CONDIMENT = 'FNB_UPDATE_CONDIMENT';
export const FNB_UPDATE_CONDIMENT_SUCCESS = 'FNB_UPDATE_CONDIMENT_SUCCESS';
export const FNB_UPDATE_CONDIMENT_FAIL = 'FNB_UPDATE_CONDIMENT_FAIL';
export const FNB_CONDIMENT_TRANSLATE = 'FNB_CONDIMENT_TRANSLATE';
export const FNB_CONDIMENT_TRANSLATE_SUCCESS = 'FNB_CONDIMENT_TRANSLATE_SUCCESS';
export const FNB_CONDIMENT_TRANSLATE_FAIL = 'FNB_CONDIMENT_TRANSLATE_FAIL';
export const FNB_CONDIMENT_TRANSLATE_DELETE = 'FNB_CONDIMENT_TRANSLATE_DELETE';
export const FNB_CONDIMENT_TRANSLATE_DELETE_SUCCESS = 'FNB_CONDIMENT_TRANSLATE_DELETE_SUCCESS';
export const FNB_CONDIMENT_TRANSLATE_DELETE_FAIL = 'FNB_CONDIMENT_TRANSLATE_DELETE_FAIL';

export const FNB_GET_OPTIONS = 'FNB_GET_OPTIONS';
export const FNB_GET_OPTIONS_SUCCESS = 'FNB_GET_OPTIONS_SUCCESS';
export const FNB_GET_OPTIONS_FAIL = 'FNB_GET_OPTIONS_FAIL';

export const FNB_SYNC_OPTIONS = 'FNB_SYNC_OPTIONS';
export const FNB_SYNC_OPTIONS_SUCCESS = 'FNB_SYNC_OPTIONS_SUCCESS';
export const FNB_SYNC_OPTIONS_FAIL = 'FNB_SYNC_OPTIONS_FAIL';

export const FNB_GET_OPTION_DETAIL = 'FNB_GET_OPTION_DETAIL';
export const FNB_GET_OPTION_DETAIL_SUCCESS = 'FNB_GET_OPTION_DETAIL_SUCCESS';
export const FNB_GET_OPTION_DETAIL_FAIL = 'FNB_GET_OPTION_DETAIL_FAIL';

export const FNB_UPDATE_OPTION = 'FNB_UPDATE_OPTION';
export const FNB_UPDATE_OPTION_SUCCESS = 'FNB_UPDATE_OPTION_SUCCESS';
export const FNB_UPDATE_OPTION_FAIL = 'FNB_UPDATE_OPTION_FAIL';
export const FNB_OPTION_TRANSLATE = 'FNB_OPTION_TRANSLATE';
export const FNB_OPTION_TRANSLATE_SUCCESS = 'FNB_OPTION_TRANSLATE_SUCCESS';
export const FNB_OPTION_TRANSLATE_FAIL = 'FNB_OPTION_TRANSLATE_FAIL';
export const FNB_OPTION_TRANSLATE_DELETE = 'FNB_OPTION_TRANSLATE_DELETE';
export const FNB_OPTION_TRANSLATE_DELETE_SUCCESS = 'FNB_OPTION_TRANSLATE_DELETE_SUCCESS';
export const FNB_OPTION_TRANSLATE_DELETE_FAIL = 'FNB_OPTION_TRANSLATE_DELETE_FAIL';

export const FNB_GET_PRODUCTS = 'FNB_GET_PRODUCTS';
export const FNB_GET_PRODUCTS_SUCCESS = 'FNB_GET_PRODUCTS_SUCCESS';
export const FNB_GET_PRODUCTS_FAIL = 'FNB_GET_PRODUCTS_FAIL';

export const FNB_SYNC_PRODUCTS = 'FNB_SYNC_PRODUCTS';
export const FNB_SYNC_PRODUCTS_SUCCESS = 'FNB_SYNC_PRODUCTS_SUCCESS';
export const FNB_SYNC_PRODUCTS_FAIL = 'FNB_SYNC_PRODUCTS_FAIL';

export const FNB_GET_PRODUCT_DETAIL = 'FNB_GET_PRODUCT_DETAIL';
export const FNB_GET_PRODUCT_DETAIL_SUCCESS = 'FNB_GET_PRODUCT_DETAIL_SUCCESS';
export const FNB_GET_PRODUCT_DETAIL_FAIL = 'FNB_GET_PRODUCT_DETAIL_FAIL';

export const FNB_UPDATE_PRODUCT = 'FNB_UPDATE_PRODUCT';
export const FNB_UPDATE_PRODUCT_SUCCESS = 'FNB_UPDATE_PRODUCT_SUCCESS';
export const FNB_UPDATE_PRODUCT_FAIL = 'FNB_UPDATE_PRODUCT_FAIL';
export const FNB_PRODUCT_TRANSLATE = 'FNB_PRODUCT_TRANSLATE';
export const FNB_PRODUCT_TRANSLATE_SUCCESS = 'FNB_PRODUCT_TRANSLATE_SUCCESS';
export const FNB_PRODUCT_TRANSLATE_FAIL = 'FNB_PRODUCT_TRANSLATE_FAIL';
export const FNB_PRODUCT_TRANSLATE_UPDATE = 'FNB_PRODUCT_TRANSLATE_UPDATE';
export const FNB_PRODUCT_TRANSLATE_UPDATE_SUCCESS = 'FNB_PRODUCT_TRANSLATE_UPDATE_SUCCESS';
export const FNB_PRODUCT_TRANSLATE_UPDATE_FAIL = 'FNB_PRODUCT_TRANSLATE_UPDATE_FAIL';
export const FNB_PRODUCT_TRANSLATE_DELETE = 'FNB_PRODUCT_TRANSLATE_DELETE';
export const FNB_PRODUCT_TRANSLATE_DELETE_SUCCESS = 'FNB_PRODUCT_TRANSLATE_DELETE_SUCCESS';
export const FNB_PRODUCT_TRANSLATE_DELETE_FAIL = 'FNB_PRODUCT_TRANSLATE_DELETE_FAIL';

export const getOutlets = createAction(FNB_GET_OUTLETS);
export const getOutletsSuccess = createAction(FNB_GET_OUTLETS_SUCCESS);
export const getOutletsFail = createAction(FNB_GET_OUTLETS_FAIL);

export const getProperties = createAction(FNB_GET_PROPERTIES);
export const getPropertiesSuccess = createAction(FNB_GET_PROPERTIES_SUCCESS);
export const getPropertiesFail = createAction(FNB_GET_PROPERTIES_FAIL);

export const syncOutlets = createAction(FNB_SYNC_OUTLETS);
export const syncOutletsSuccess = createAction(FNB_SYNC_OUTLETS_SUCCESS);
export const syncOutletsFail = createAction(FNB_SYNC_OUTLETS_FAIL);
export const updateOutlet = createAction(FNB_UPDATE_OUTLET);
export const updateOutletSuccess = createAction(FNB_UPDATE_OUTLET_SUCCESS);
export const updateOutletFail = createAction(FNB_UPDATE_OUTLET_FAIL);

export const getMenus = createAction(FNB_GET_MENUS);
export const getMenusSuccess = createAction(FNB_GET_MENUS_SUCCESS);
export const getMenusFail = createAction(FNB_GET_MENUS_FAIL);

export const syncMenus = createAction(FNB_SYNC_MENUS);
export const syncMenusSuccess = createAction(FNB_SYNC_MENUS_SUCCESS);
export const syncMenusFail = createAction(FNB_SYNC_MENUS_FAIL);

export const syncMenuItems = createAction(FNB_SYNC_MENU_ITEMS);
export const syncMenuItemsSuccess = createAction(FNB_SYNC_MENU_ITEMS_SUCCESS);
export const syncMenuItemsFail = createAction(FNB_SYNC_MENU_ITEMS_FAIL);

export const getMenuItems = createAction(FNB_GET_MENU_ITEMS);
export const getMenuItemsSuccess = createAction(FNB_GET_MENU_ITEMS_SUCCESS);
export const getMenuItemsFail = createAction(FNB_GET_MENU_ITEMS_FAIL);

export const updateMenuItem = createAction(FNB_UPDATE_MENU_ITEM);
export const updateMenuItemSuccess = createAction(FNB_UPDATE_MENU_ITEM_SUCCESS);
export const updateMenuItemFail = createAction(FNB_UPDATE_MENU_ITEM_FAIL);

export const getMenuDetail = createAction(FNB_GET_MENU_DETAIL);
export const getMenuDetailSuccess = createAction(FNB_GET_MENU_DETAIL_SUCCESS);
export const getMenuDetailFail = createAction(FNB_GET_MENU_DETAIL_FAIL);

export const updateMenu = createAction(FNB_UPDATE_MENU);
export const updateMenuSuccess = createAction(FNB_UPDATE_MENU_SUCCESS);
export const updateMenuFail = createAction(FNB_UPDATE_MENU_FAIL);

export const translateMenu = createAction(FNB_MENU_TRANSLATE);
export const translateMenuSuccess = createAction(FNB_MENU_TRANSLATE_SUCCESS);
export const translateMenuFail = createAction(FNB_MENU_TRANSLATE_FAIL);
export const deleteMenuTranslate = createAction(FNB_MENU_TRANSLATE_DELETE);
export const deleteMenuTranslateSuccess = createAction(FNB_MENU_TRANSLATE_DELETE_SUCCESS);
export const deleteMenuTranslateFail = createAction(FNB_MENU_TRANSLATE_DELETE_FAIL);

export const getItemDetail = createAction(FNB_GET_ITEM_DETAIL);
export const getItemDetailSuccess = createAction(FNB_GET_ITEM_DETAIL_SUCCESS);
export const getItemDetailFail = createAction(FNB_GET_ITEM_DETAIL_FAIL);

export const getCondiments = createAction(FNB_GET_CONDIMENTS);
export const getCondimentsSuccess = createAction(FNB_GET_CONDIMENTS_SUCCESS);
export const getCondimentsFail = createAction(FNB_GET_CONDIMENTS_FAIL);

export const syncCondiments = createAction(FNB_SYNC_CONDIMENTS);
export const syncCondimentsSuccess = createAction(FNB_SYNC_CONDIMENTS_SUCCESS);
export const syncCondimentsFail = createAction(FNB_SYNC_CONDIMENTS_FAIL);

export const getCondimentDetail = createAction(FNB_GET_CONDIMENT_DETAIL);
export const getCondimentDetailSuccess = createAction(FNB_GET_CONDIMENT_DETAIL_SUCCESS);
export const getCondimentDetailFail = createAction(FNB_GET_CONDIMENT_DETAIL_FAIL);

export const updateCondiment = createAction(FNB_UPDATE_CONDIMENT);
export const updateCondimentSuccess = createAction(FNB_UPDATE_CONDIMENT_SUCCESS);
export const updateCondimentFail = createAction(FNB_UPDATE_CONDIMENT_FAIL);
export const translateCondiment = createAction(FNB_CONDIMENT_TRANSLATE);
export const translateCondimentSuccess = createAction(FNB_CONDIMENT_TRANSLATE_SUCCESS);
export const translateCondimentFail = createAction(FNB_CONDIMENT_TRANSLATE_FAIL);
export const deleteCondimentTranslate = createAction(FNB_CONDIMENT_TRANSLATE_DELETE);
export const deleteCondimentTranslateSuccess = createAction(FNB_CONDIMENT_TRANSLATE_DELETE_SUCCESS);
export const deleteCondimentTranslateFail = createAction(FNB_CONDIMENT_TRANSLATE_DELETE_FAIL);

export const getOptions = createAction(FNB_GET_OPTIONS);
export const getOptionsSuccess = createAction(FNB_GET_OPTIONS_SUCCESS);
export const getOptionsFail = createAction(FNB_GET_OPTIONS_FAIL);

export const syncOptions = createAction(FNB_SYNC_OPTIONS);
export const syncOptionsSuccess = createAction(FNB_SYNC_OPTIONS_SUCCESS);
export const syncOptionsFail = createAction(FNB_SYNC_OPTIONS_FAIL);

export const getOptionDetail = createAction(FNB_GET_OPTION_DETAIL);
export const getOptionDetailSuccess = createAction(FNB_GET_OPTION_DETAIL_SUCCESS);
export const getOptionDetailFail = createAction(FNB_GET_OPTION_DETAIL_FAIL);

export const updateOption = createAction(FNB_UPDATE_OPTION);
export const updateOptionSuccess = createAction(FNB_UPDATE_OPTION_SUCCESS);
export const updateOptionFail = createAction(FNB_UPDATE_OPTION_FAIL);

export const getProducts = createAction(FNB_GET_PRODUCTS);
export const getProductsSuccess = createAction(FNB_GET_PRODUCTS_SUCCESS);
export const getProductsFail = createAction(FNB_GET_PRODUCTS_FAIL);

export const syncProducts = createAction(FNB_SYNC_PRODUCTS);
export const syncProductsSuccess = createAction(FNB_SYNC_PRODUCTS_SUCCESS);
export const syncProductsFail = createAction(FNB_SYNC_PRODUCTS_FAIL);

export const getProductDetail = createAction(FNB_GET_PRODUCT_DETAIL);
export const getProductDetailSuccess = createAction(FNB_GET_PRODUCT_DETAIL_SUCCESS);
export const getProductDetailFail = createAction(FNB_GET_PRODUCT_DETAIL_FAIL);

export const updateProduct = createAction(FNB_UPDATE_PRODUCT);
export const updateProductSuccess = createAction(FNB_UPDATE_PRODUCT_SUCCESS);
export const updateProductFail = createAction(FNB_UPDATE_PRODUCT_FAIL);
export const translateProduct = createAction(FNB_PRODUCT_TRANSLATE);
export const translateProductSuccess = createAction(FNB_PRODUCT_TRANSLATE_SUCCESS);
export const translateProductFail = createAction(FNB_PRODUCT_TRANSLATE_FAIL);
export const deleteProductTranslateById = createAction(FNB_PRODUCT_TRANSLATE_DELETE);
export const deleteProductTranslateByIdSuccess = createAction(FNB_PRODUCT_TRANSLATE_DELETE_SUCCESS);
export const deleteProductTranslateByIdFail = createAction(FNB_PRODUCT_TRANSLATE_DELETE_FAIL);
export const translateOption = createAction(FNB_OPTION_TRANSLATE);
export const translateOptionSuccess = createAction(FNB_OPTION_TRANSLATE_SUCCESS);
export const translateOptionFail = createAction(FNB_OPTION_TRANSLATE_FAIL);
export const deleteOptionTranslate = createAction(FNB_OPTION_TRANSLATE_DELETE);
export const deleteOptionTranslateSuccess = createAction(FNB_OPTION_TRANSLATE_DELETE_SUCCESS);
export const deleteOptionTranslateFail = createAction(FNB_OPTION_TRANSLATE_DELETE_FAIL);

export const FNB_CREATE_PRODUCT_TRANSLATE = 'FNB_CREATE_PRODUCT_TRANSLATE';
export const FNB_CREATE_PRODUCT_TRANSLATE_SUCCESS = 'FNB_CREATE_PRODUCT_TRANSLATE_SUCCESS';
export const FNB_CREATE_PRODUCT_TRANSLATE_FAIL = 'FNB_CREATE_PRODUCT_TRANSLATE_FAIL';

export const FNB_UPDATE_PRODUCT_TRANSLATE = 'FNB_UPDATE_PRODUCT_TRANSLATE';
export const FNB_UPDATE_PRODUCT_TRANSLATE_SUCCESS = 'FNB_UPDATE_PRODUCT_TRANSLATE_SUCCESS';
export const FNB_UPDATE_PRODUCT_TRANSLATE_FAIL = 'FNB_UPDATE_PRODUCT_TRANSLATE_FAIL';

export const FNB_DELETE_PRODUCT_TRANSLATE = 'FNB_DELETE_PRODUCT_TRANSLATE';
export const FNB_DELETE_PRODUCT_TRANSLATE_SUCCESS = 'FNB_DELETE_PRODUCT_TRANSLATE_SUCCESS';
export const FNB_DELETE_PRODUCT_TRANSLATE_FAIL = 'FNB_DELETE_PRODUCT_TRANSLATE_FAIL';

export const createProductTranslate = createAction(FNB_CREATE_PRODUCT_TRANSLATE);
export const createProductTranslateSuccess = createAction(FNB_CREATE_PRODUCT_TRANSLATE_SUCCESS);
export const createProductTranslateFail = createAction(FNB_CREATE_PRODUCT_TRANSLATE_FAIL);

export const updateProductTranslate = createAction(FNB_UPDATE_PRODUCT_TRANSLATE);
export const updateProductTranslateSuccess = createAction(FNB_UPDATE_PRODUCT_TRANSLATE_SUCCESS);
export const updateProductTranslateFail = createAction(FNB_UPDATE_PRODUCT_TRANSLATE_FAIL);

export const deleteProductTranslate = createAction(FNB_DELETE_PRODUCT_TRANSLATE);
export const deleteProductTranslateSuccess = createAction(FNB_DELETE_PRODUCT_TRANSLATE_SUCCESS);
export const deleteProductTranslateFail = createAction(FNB_DELETE_PRODUCT_TRANSLATE_FAIL);
